export default __webpack_public_path__ + "static/media/FondoGrisClaro.f7cc681c.jpg";